import { mapActions, mapGetters, mapMutations } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  computed: {
    ...mapGetters('common/staticData', [
      'getLocale',
      'getLanguage',
      'getTimezone',
      'getTranslationOptions',
      'getTranslation',
      'getModalName',
      'getModalIsOpen',
    ]),
  },
  methods: {
    ...mapActions('common/staticData', ['fetchTranslations']),
    ...mapMutations('common/staticData', [
      'setLocale',
      'setLanguage',
      'setTimezone',
      'setTranslations',
      'setTranslation',
      'openModal',
      'closeModal',
    ]),
  },
});
